<template>
  <v-footer :color="footerColor" class="secondary--text">
    <v-row justify="center" no-gutters>
      <v-col class="text-center" cols="12">
        Copyright © {{ anio }}. Todos los derechos reservados - IT Management
      </v-col>
    </v-row>
  </v-footer>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'Footer',
  data() {
    return {
      anio: new Date().getFullYear(),
    };
  },
  computed: {
    ...mapState(['colorFooter']),
    footerColor() {
      return this.colorFooter || 'primary';
    },
  },
};
</script>
